import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { Grid } from "@mui/material";
import { useContext, useEffect } from "react";
import { ProviderProjectDashboard } from "../ProjectSupportDashboard";

const ProjectPieChartSection = () => {

  const {
    lstSectionPieChart,
  } = useContext(ProviderProjectDashboard);

  useEffect(() => {
    PieChartSetion();
  }, [lstSectionPieChart])

  const PieChartSetion = () => {

    am4core.addLicense("CH208466903"); //รหัสรายเส้นใช้ไม่ให้ขึ้นเส้นโลโก้

    // Create chart instance
    let chart = am4core.create("PieChartSetion", am4charts.PieChart3D);

    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
    chart.legend = new am4charts.Legend();

    const arrData = lstSectionPieChart.map((item) => {
      let resultData = {
        "sSectionName": item.sSectionName,
        "nProjectTotal": item.nProjectTotal,
        "nProjectPrice": item.nProjectPrice
      };
      return resultData;
    });
    chart.data = arrData
    chart.innerRadius = 100;

    let series = chart.series.push(new am4charts.PieSeries3D());
    series.dataFields.value = "nProjectTotal";
    series.dataFields.category = "sSectionName";
    series.slices.template.tooltipText = "{category}: จำนวนเงิน {nProjectPrice} บาท มี {value} โครงการ ({value.percent.formatNumber('#.00')}%)";
    
  }
  return (
    <>
      <Grid item xs={12} md={12}>
        <div id="PieChartSetion" style={{ width: "100%", height: "450px" }}></div>
      </Grid>
    </>
  )
}
export default ProjectPieChartSection